module.exports = __webpack_public_path__ + "img/dashboard.d7424eac.svg";